export const tableFields = [
  { key: 'first_name' },
  { key: 'last_name' },
  { key: 'email' },
  { key: 'method' },
  { key: 'event' },
  { key: 'location' },
  { key: 'assigned_to', label: 'Assigned To' },
  { key: 'date_created' },
  { key: 'actions', label: '' },
];

export const linkedTableFields = [
  { key: 'first_name' },
  { key: 'last_name' },
  { key: 'email' },
  { key: 'method' },
  { key: 'event' },
  { key: 'date_created' },
  { key: 'petition', label: 'Petition ID' },
  { key: 'actions', label: '' },
];
